import BigNumber from 'bignumber.js';

import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { NetworkUsageCard } from '../NetworkUsageCard';
import { cachedRequestsCardTranslation } from './translation';
import { getCachedRequestsPercent } from './utils/getCachedRequestsPercent';
import { useStats } from '../StatsProvider';

interface CachedRequestsCardProps {
  className?: string;
  disabled?: boolean;
}

const cachedRequests = 0;

export const CachedRequestsCard = ({
  className,
  disabled,
}: CachedRequestsCardProps) => {
  const { loading, totalRequests } = useStats();
  const { keys, t } = useTranslation(cachedRequestsCardTranslation);

  const value = totalRequests
    ? getCachedRequestsPercent(
        new BigNumber(totalRequests),
        new BigNumber(cachedRequests),
      )
    : totalRequests.toString();

  return (
    <NetworkUsageCard
      className={className}
      disabled={disabled}
      loading={loading}
      title={t(keys.title)}
      value={value}
    />
  );
};
